// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"55da339f","255":"96b52ec1","256":"69cbe97e","787":"77a32dc1","913":"4e3cd7be","980":"8e1c552b","981":"a4a42b29","987":"e16933e3"}[chunkId] + ".chunk.js";
};